import { Component, OnInit } from '@angular/core';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
import {UtilsService} from '../common/services/utils.service';
import * as $ from 'jquery';
declare var addBootStrapPagination: Function;
declare var show_okshan_alert: Function;
declare var add_select_box_design: Function;

@Component({
  selector: 'app-my-inspection',
  templateUrl: './my-inspection.component.html',
  styleUrls: ['./my-inspection.component.css']
})
export class MyInspectionComponent implements OnInit {

  carsList:any=[];
  fileUrl:string="";
  sessionProfileType:number=-1;
  actionStatus:boolean=false;
  constructor(private httpserviceService:HttpserviceService,private sessionsService:SessionsService,private router:Router,private _constant: ConstantsService) { }

  ngOnInit(): void {
      if(this.sessionsService.getSession("login_status")==null)
    {       
         window.location.href="#/visitor";       
    }
    else if(!this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/visitor";
       }
    window.scrollTo(0, 0);
    if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    if(this.sessionsService.getSession("profile_type")!=null && this.sessionsService.getSession("status")!=null)
    {
       if(this.sessionsService.getSession("profile_type")!=-1 && this.sessionsService.getSession("status")==1)
       {
         this.actionStatus=true;
       }
    }
    if(!this.actionStatus || (this.sessionProfileType!=1 && this.sessionProfileType!=2))
    {
      show_okshan_alert("You don't have access of this page");
      this.router.navigate(['home']);      
    }
    this.fileUrl=this._constant.uploadFileUrl
    setTimeout(() => {      
      this.myInspectionCarsList();
      add_select_box_design('.select2-show-search');
    }, 500);
  }

  /** myInspectionCarsList function used to get my inspection cars list  */
  myInspectionCarsList()
  {
    let result =this.httpserviceService.myInspectionCarsListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.myInspectionCarsListResponse(data),
     err => {
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** myInspectionCarsListResponse function used to handle response */
  myInspectionCarsListResponse(response)
  {
    console.log('myInspectionCarsListResponse '+ response);
    if(response.status==="success")  
     {       
      this.carsList=response.list;  
      setTimeout(() => {
      addBootStrapPagination("short-filter");   
      }, 100);
            
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

  /** carDetail function used to open car detail */
  carDetail(type,id)
  {
    if(type==1)
    {
    this.router.navigate(['fixed-price-car-detail'], { queryParams: { id: id } });
    }
    else if(type==2)
    {
    this.router.navigate(['auction-car-detail'], { queryParams: { id: id } });
    }
  }

  /** method used to open inspection detail page */
  inspectionDetail(id)
  {
  this.router.navigate(['inspection-detail'], { queryParams: { id: id } });  
  }

}
